<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-4 offset-md-3 offset-sm-2 offset-0 mt-3">
                
                <div class="card">
                    <form class="card-body">
                        <!-- auth header logo -->
                        <app-header></app-header>

                        <!-- display alert message desktop view -->
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n3 mt-3 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>

                        <div class="mt-4">
                            <span class="font-weight-bold">Email Address</span>
                            <input v-model="email" type="text" ref="email" class="form-control no-lines">
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold">Your Password</span>
                            <div class="input-group">
                                <input v-model="password" :type="showPassword ? `text` : `password`" required class="form-control no-lines">
                                <div class="input-group-append">
                                    <div @click.prevent="showPasswordFxn" class="input-group-text bg-light font-weight-bold clickable">
                                        <i v-if="showPassword" class="fas fa-eye-slash"></i>
                                        <i v-else class="fas fa-eye"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-center mt-4">
                            <button @click.prevent="userSignin" class="btn btn-dark-green form-control">Sign In</button>
                        </div>
                        <div class="mt-4 text-center font-weight-bold">
                            <hr>
                            <p><router-link :to="{ name: 'recovery' }" class="text-dark-green">Forgot password</router-link></p>
                            <p>New shopper? <router-link :to="{ name: 'signup' }" class="text-dark-green">Start here</router-link></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { webpageTitle } from '@/store/dry'

import Header from '../shared/Header.vue'
import LayoutAuth from '@/layouts/Auth.vue' 

export default {
    data() {
        return {
            email: '',
            password: '',
            showPassword: false,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(["signIn"]),
        userSignin() {
            if(this.email == ''){ this.msg = "Your email or handle is required"; return }
            if(this.password == ''){ this.msg = "Your password is required"; return }
            let userObj = {
                email: this.email.toLowerCase(),
                password: this.password
            }
            this.signIn(userObj)
            .then((data) => {
                // data is only available if sign in failed
                if(data){
                    this.msg = data.msg
                    return
                }
                // send user back to the route of origin after successful signin
                if(this.lastRoutePath()){
                    this.$router.push(this.lastRoutePath()).catch((e) => {})
                } 
                // send to profile if no lastRoutePath
                else {
                    // // classic - redirects user to profile page - for aNewItem company posting alone
                    // this.$router.push({ name: 'profile' }).catch((e) => {})
                    
                    // rebranded - redirects shopper to customer account page now
                    this.$router.push({ name: 'customer-account' }).catch((e) => {})
                }
            }).catch((e) => {
                this.password = ''
                this.msg = "We are having issues reaching our resoruces at this time. Check back soon."
            })
        },
        lastRoutePath() {
            let lastUrlPath = localStorage.getItem('_r68dt43u')
            if(lastUrlPath && lastUrlPath !== "/") {
                return lastUrlPath
            }
            return false
        },
        showPasswordFxn() {
            this.showPassword = !this.showPassword
        },
    },
    components: {
        appHeader: Header
    },
    created() {
        webpageTitle(`Sign in`)
        this.$emit('update:layout', LayoutAuth)
    }
}
</script>
